import styles from './measureForm.module.css'
import { Form, Data, FormField, ModalId, useUIActions, FieldType, option, FieldValue, SelectField, NumberField, O } from "../../../../../features/ui"
import { firstItem } from "../../../../../utils/listUtils"
import { useMemo, useState } from "react"
import { getUnitTypeCategory, sortUnitTypes } from "../../../../products"
import { Labels } from '../../../../../features/data-types'
import { useUnitTypeLoaders, useUnitTypeHooks } from '../../../../stock'
import { MeasureType } from '../../../state/types'

type Props = {
    measureData?: Data
    measureTypes: MeasureType[]
    onSubmit: (data: Data) => void
}

export const MeasureForm = (props: Props) => {
    const { measureData, measureTypes, onSubmit } = props
    const createMode = !measureData
    
    const unitTypeLoaders = useUnitTypeLoaders()

    const unitTypes = useMemo(() => unitTypeLoaders().findAllUnitTypes(), [])
    const categoryUnitTypes = (measureType?: MeasureType) =>
        unitTypes.sort(sortUnitTypes).filter(unitType => measureType && unitType.category === getUnitTypeCategory(measureType))
    
    const defaultType = measureTypes.includes(MeasureType.WEIGHT) ? MeasureType.WEIGHT : firstItem(measureTypes)
    const defaultUnitType = (measureType?: MeasureType) => firstItem(categoryUnitTypes(measureType))?.id

    const [type, setType] = useState<O<MeasureType>>((measureData?.type as O<MeasureType>) || defaultType)
    const [units, setUnits] = useState<O<number>>((measureData?.units as O<number>) || 1)
    const [unitTypeId, setUnitTypeId] = useState<O<string>>((measureData?.unitTypeId as O<string>) || defaultUnitType(defaultType))

    const { getDefaultUnitTypeId } = useUnitTypeHooks()

    const { closeModal } = useUIActions()
    
    const typeOptions = useMemo(() => measureTypes.map(type => option(type, Labels.measureTypeLabel(type))), [measureTypes])
    const unitTypeOptions = useMemo(() => categoryUnitTypes(type).map(unitType => option(unitType.id, unitType.name)), [type])

    const onChangeType = (value?: FieldValue) => {
        const newType = value as O<MeasureType>
        setType(newType)
        const newUnitTypes = categoryUnitTypes(newType)
        const defaultUnitTypeId = newType ? getDefaultUnitTypeId(newType) : firstItem(newUnitTypes)?.id
        setUnitTypeId(defaultUnitTypeId)
    }

    const onChangeUnitType = (value?: FieldValue) => {
        setUnitTypeId(value as O<string>)
    }

    const fields: FormField[] = [
        {
            name: 'type',
            type: FieldType.SELECT,
            defaultValue: type,
            options: typeOptions,
            label: 'Tipo',
            onChange: onChangeType
        },
        {
            name: 'units',
            type: FieldType.NUMBER,
            label: 'Valor',
            render: () => {
                return <div className={styles.unitsContainer}>
                    <NumberField
                        id="units"
                        defaultValue={units}
                        min={0.01}
                        className={styles.units}
                        onChange={setUnits}
                    />
                    <SelectField
                        id="unitTypeId"
                        value={unitTypeId}
                        options={unitTypeOptions}
                        onChange={onChangeUnitType}
                    />
                </div>
            }
        }
    ]

    const handleSubmit = () => {
        const newMeasure = {
            type,
            units,
            unitTypeId
        }
        onSubmit(newMeasure)
        closeModal(ModalId.MEASURE_FORM)
    }

    const handleCancel = () => closeModal(ModalId.MEASURE_FORM)

    return (
        <Form
            formId="measure-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
